import styled from 'styled-components';
import { theme } from 'styles';

const ModalContainer = styled.div`
  width: fit-content;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden;
  width: 400px;

  .title {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    padding: 17px 16px 16px;
    border-bottom: 1px solid ${theme.colors.gray100};
  }

  .con {
    padding: 24px;
  }

  .btn {
    display: flex;
    padding-top: 32px;
    gap: 8px;
    justify-content: flex-end;

    & > div {
      width: 100px;
      height: 40px;
      background-color: ${theme.colors.gray300};
    }
  }
`;

export default ModalContainer;